import React from "react"
import { Container, Content } from "native-base"
import Reminders from "../Reminders"
import BookingsList from "./BookingList"
import styles from "./styles"
import { Navigation } from "components/types"

interface Props {
  navigation: Navigation
}

export default ({ navigation }: Props) => (
  <Container style={styles.container}>
    <Content>
      <Reminders navigation={navigation} />
      <BookingsList navigation={navigation} />
    </Content>
  </Container>
)
